export default __webpack_public_path__ + "static/media/data-transfer.0b72c662.svg";